import React from "react"
import { classNames } from "./utils"

const RotatingTitle = ({ rotatingTexts, preText, postText }) => (
  <h1 className="h1 rotating-title">
    {preText && <div>{preText}</div>}
    <div style={{ position: "relative", overflowY: "hidden" }}>
      <br />
      <div
        className={classNames(
          "rotating-title-message",
          `rotating-title-message-${rotatingTexts.length}`
        )}
      >
        {rotatingTexts.concat(rotatingTexts[0]).map((text, i) => (
          <div key={i} className="word">
            {text}
          </div>
        ))}
      </div>
    </div>
    {postText ? <div>{postText}</div> : null}
  </h1>
)

export default RotatingTitle
